import { useAppSelector } from '@app/model/store'
import { TypeClientResponsive } from '@app/model/types'

export const useClientResponsive = (): TypeClientResponsive => {
  return useAppSelector((state) => state.global.client.responsive)
}
